// Keeps the instrument a visitor selected before they had an account, so the
// rental flow can resume after register/login/profile completion. Only UI
// state lives here — auth, profile completeness and availability are all
// enforced server-side by the reserve endpoint.
const KEY = 'pendingInstrument';
const API_BASE_URL = process.env.REACT_APP_API_URL;

export const setPendingInstrument = (instrument) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(instrument));
  } catch {
    /* storage unavailable — flow simply won't resume */
  }
};

export const getPendingInstrument = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY));
  } catch {
    return null;
  }
};

export const clearPendingInstrument = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};

/**
 * Try to continue with the remembered instrument after authentication.
 * Returns true when it navigated somewhere (rent flow or profile),
 * false when there is nothing pending / the instrument is gone.
 */
export const resumePendingReserve = async (navigate) => {
  const instrument = getPendingInstrument();
  if (!instrument) return false;

  try {
    const response = await fetch(
      `${API_BASE_URL}/api/instruments/${instrument.instrumentId}/reserve`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ status: 'Reserved' }),
      }
    );

    if (response.ok) {
      clearPendingInstrument();
      navigate('/rent', { state: { instrument: { ...instrument, status: 'Reserved' } } });
      return true;
    }
    if (response.status === 403) {
      // Profile incomplete — keep the instrument pending, finish profile first
      navigate('/profile');
      return true;
    }
    // Instrument no longer available (or other error) — drop it
    clearPendingInstrument();
    return false;
  } catch {
    return false;
  }
};
